import styled from '@emotion/styled';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

import { DialogFlexSales } from '../components';

import SynchroExecutionForm from '../components/SynchroExecution/SynchroExecutionForm';

const DialogContentStyled = styled(DialogContent)`
  width: 25em; // Un poco más ancho que Reprocess para que quepan las fechas
`;

const SynchroExecutionNew = () => {
  const { t } = useTranslation();
  return (
    <DialogFlexSales open maxWidth="sm">
      <DialogTitle>{t('synchro4me.form.title')}</DialogTitle>
      <DialogContentStyled>
        <SynchroExecutionForm />
      </DialogContentStyled>
    </DialogFlexSales>
  );
};

export default SynchroExecutionNew;
